import { Form, Formik } from 'formik'
import { observer } from 'mobx-react-lite'
import React, { useState, useContext } from 'react'
import { useParams } from 'react-router-dom'
import axiosService from '../../../../../../../utils/AxiosService'
import { CampaignContext } from '../../../../../../../contexts/CampaignContext'
import Input from '../../../../../../FormComponents/Input'
import { toastError, toastSuccess } from '../../../../../../FormComponents/Toasts'
import { useReadOnly } from '../../../../../../../contexts/ReadOnlyContext'

export default observer(function ImpressionField({ action }) {
  const readOnly = useReadOnly()
  const { id } = useParams()
  const { primaryScenarioId } = useContext(CampaignContext)
  const [currentTimeout, setCurrentTimeout] = useState(null)

  const changeImpression = impression => {
    if (currentTimeout) clearTimeout(currentTimeout)
    setCurrentTimeout(setTimeout(() => submitImpression(impression), 1000))
  }

  const handleFormSubmit = values => {
    if (currentTimeout) clearTimeout(currentTimeout)
    const value = typeof values?.impression === 'object'
      ? values.impression?.impression
      : values?.impression
    submitImpression(value)
  }

  const submitImpression = impression => {
    axiosService.patch(`/api/project_manager/campaigns/${id}/campaign_scenarios/${primaryScenarioId}/actions/${action.id}`, { campaign_scenario_action: { impression }})
    .then((updatedAction) => {
      toastSuccess('Impression updated')
      action.impression = updatedAction.impression
    })
    .catch(({ data: { error }}) => toastError(error))
  }

  return (
    <div>
      <Formik
        initialValues={{ impression: action.impression }}
        onSubmit={handleFormSubmit}
      >
        {({ errors, touched, handleBlur, handleChange, values }) => (
          <Form className="w-full">
            <div className="relative">
              <Input
                disabled={readOnly}
                error={touched.impression && errors.impression}
                name="impression"
                noLabelPadding
                onChange={(e) => {
                  changeImpression(e.target.value)
                  handleChange(e)
                }}
                onBlur={handleBlur}
                value={values.impression}
                className="pr-0"
                overrideClassName="h-7"
                topMargin="mt-0"
              />
            </div>
          </Form>
        )}
      </Formik>
    </div>
  )
})